import axios from "axios";
import {urlDomain } from '../config/constant';
const apiDomain = urlDomain();

export const  blackList = (requestParams) => {
    const apiUrl = `${apiDomain}/check-blacklist`;
    
    return axios.post(apiUrl, requestParams);
}

export const past7DaysBuyleads = (glid) => {
    const apiUrl = `${apiDomain}/postbuyleads`;
    return axios.post(apiUrl, {'glid':`${glid}`})
}